import { Location } from "./Location";
export interface Level3Details {
  merchantReference?: string;
  customerReference?: string;
  lineItems: LineItem[];
  shipToZip?: string;
  shippingAmount?: number;
  shipFromZip?: string;
}
export interface LineItem {
  discountAmount: number;
  productCode: string;
  productDescription: string;
  quantity: number;
  taxAmount: number;
  unitCost: number;
}
export interface PaymentMethodDetails {
  brand: string;
  lastFour: string;
  expMonth: number;
  expYear: number;
  cardholderName: string;
  network: string;
}

export type PaymentStatus =
  | "requires_payment_method"
  | "requires_confirmation"
  | "requires_action"
  | "processing"
  | "requires_capture"
  | "canceled"
  | "succeeded";

export interface PermitClientPayment {
  tenantName: string;
  merchantID: string;
  amount: number;
  paymentMethodID: string;
  address: Location;
  level3Details: Level3Details;
  metadata: Record<string, unknown>;
  merchantReference: string;
  permitID: string;
  permitNumber: string;
  needsApproval: boolean;
}

export interface PermitTransaction {
  id: number;
  status: PermitTransactionStatus;
  permitID: number;
  paymentID: string; // payment intent ID
  tenantID: number;
  entityID: number;
  entityTypeID: number;
  permitTypeID: number;
  created?: Date | string;
  updated?: Date | string;
  data?: PermitTransactionData;
}

export enum PermitTransactionStatus {
  NONE = "unpaid",
  PAID = "paid",
  REFUNDED = "refunded",
  HOLD = "hold",
  CANCELLED = "cancelled",
}

export interface PermitTransactionData {
  error?: string;
  details?: PermitClientPayment;
  paymentMethodDetails?: PaymentMethodDetails;
}
